import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalHeader, useStyleConfig,
} from '@chakra-ui/react';
import { ModalStyle as styleRaw } from './ModalStyle';
import AdvancedSelect from '../../formElements/AdvancedSelect';

const JobIndustryModal = ({props,resumeIndex}) => {
  const style = styleRaw.variants.jobIndustry;


  const variant = 'wrapper';
  const stateProps = props.stateProps;
  const aiIndustryqObj = stateProps.sectionData.sectionName === 'resumes' ? stateProps.aiIndustryData.aiIndustryQObj : stateProps.aiIndustryPEData.aiIndustryQObj;
 /*const preventBlur=(e)=> {
    e.preventDefault();
  }*/
  return (
    <Modal
      sx={style.modal}
      isCentered
      isOpen={stateProps.isJobIndustryOpen}
      onClose={stateProps.onJobIndustryClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent style={style.modalContent} >
        <ModalHeader>Select an Industry</ModalHeader>
        <ModalBody>
          <AdvancedSelect fieldName="test" qObj={aiIndustryqObj} props={props} index={resumeIndex} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
/*

        <ModalFooter>
          <Flex style={style.modalFooter}>
            <Button
              sx={{...buttonStyles.primary}}
              onClick={stateProps.onJobIndustryClose}
            >Choose</Button>
          </Flex>
        </ModalFooter>
 */
export default JobIndustryModal;
